export default __webpack_public_path__ + "static/web-development-illustration-60e0a4ab2c281cc89bdb8f16e8bf5ca6.svg";